module.exports = __webpack_public_path__ + "assets/tutorials/Adding_Survey_Question.png";